<ng-container *transloco="let t">
  <div class="order-section-item">
    <div class="order-section-item-title">
      {{ t('orderDetails.shippingOption') }}
    </div>
    <div class="order-section-item-value">
      {{ label() ?? shippingOption().name }}
    </div>
  </div>
  @if (isDelivery()) {
    @if (shippingAddress()) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.address') }}</div>
        <div class="order-section-item-value">
          @if (addressLink()) {
            <a class="ui-help-link" [href]="addressLink()" target="_blank">
              {{ shippingAddress() }}
            </a>
          } @else {
            <span>{{ shippingAddress() }}</span>
          }
        </div>
      </div>
    }
    @if (addressHints()) {
      <div class="order-section-item">
        <div class="order-section-item-title">
          {{ t('orderDetails.references') }}
        </div>
        <div class="order-section-item-value">
          {{ addressHints() }}
        </div>
      </div>
    }
    @if (displayShippingEstimate()) {
      @let shippingEstimateValue = shippingEstimate();
      @let shippingOrderValue = shippingOrder();

      @if (shippingEstimateValue && !shippingOrderValue) {
        <div class="order-section-item">
          <div class="order-section-item-title">Envío</div>
          <div class="order-section-item-value" style="display: flex; align-items: center; gap: 0.5rem;">
            <pxw-button
              (click)="
                shippingEstimateValue.offerId ? confirmShipping.emit() : createShipping.emit()
              "
              [loading]="isShippingRequestInProgress()"
              [disabled]="isPrimaryButtonDisabled()"
              color="yellow"
              display="inline"
              size="sm"
              [rounded]="true"
            >
              <pxw-icon icon="shipping" />
              {{ shippingButtonText() }}
            </pxw-button>
            @if (isDedicatedService()) {
              <pxw-tooltip [text]="t('orderDetails.requestExternalDelivery')" [openDelay]="200">
                <pxw-button
                  (click)="createOndemandShipping.emit()"
                  [loading]="isOndemandShippingRequestInProgress()"
                  [disabled]="isSecondaryButtonDisabled()"
                  color="yellow"
                  display="inline"
                  size="sm"
                  appareance="outline"
                  [rounded]="true"
                >
                  <pxw-icon icon="moto-zap" size="xs" />
                </pxw-button>
              </pxw-tooltip>
            }
          </div>
        </div>
      }

      @if (shippingEstimateValue && shippingEstimateValue?.error) {
        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('orderDetails.shippingError') }}
          </div>
          <div class="order-section-item-value">
            {{ shippingEstimateValue.error }}
          </div>
        </div>
      }

      @if (shippingEstimateValue) {
        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('orderDetails.providerName') }}
          </div>
          <div class="order-section-item-value">
            <img
              [src]="
                '/assets/images/integration-providers/' +
                shippingEstimateValue.providerName +
                '.webp'
              "
              alt="{{ shippingEstimateValue.providerName }}"
              class="provider-logo"
            />
          </div>
        </div>
        @if (agencyInfo(); as agency) {
          <div class="order-section-item">
            <div class="order-section-item-title">
              {{ t('orderDetails.pickupBranch') }}
            </div>
            <div class="order-section-item-value agency-info">
              <strong>{{ agency.name }}</strong>
              <span>{{ agency.address }}, {{ agency.city }}</span>
              @if (agency.schedule) {
                <small>{{ agency.schedule }}</small>
              }
            </div>
          </div>
        }
      }

      @if (shippingOrderValue) {
        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('orderDetails.shippingStatus') }}
          </div>
          <div class="order-section-item-value">
            <pxw-order-shipping-status 
              [status]="shippingOrderValue.status" 
              [providerName]="shippingOrderValue.providerName" 
            />
          </div>
        </div>

        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('orderDetails.confirmationCode') }}
          </div>
          <div class="order-section-item-value">
            {{ shippingOrderValue.shippingId }}
          </div>
        </div>

        @if (shippingOrderValue.verificationCode) {
          <div class="order-section-item">
            <div class="order-section-item-title">
              {{ t('orderDetails.verificationCode') }}
            </div>
            <div class="order-section-item-value">
              {{ shippingOrderValue.verificationCode }}
            </div>
          </div>
        }

        @if (shippingOrderValue.estimatedDeliveryTime) {
          <div class="order-section-item">
            <div class="order-section-item-title">
              {{ t('orderDetails.estimatedDeliveryTime') }}
            </div>
            <div class="order-section-item-value">
              {{ shippingOrderValue.estimatedDeliveryTime | date: 'dd/MM/yyyy - HH:mm' }}hs
            </div>
          </div>
        }
        @if (shippingOrderValue.status !== 'CANCELLED' && shippingOrderValue.trackingUrl) {
          <div class="order-section-item">
            <div class="order-section-item-title">
              {{ t('orderDetails.trackingUrl') }}
            </div>
            <div class="order-section-item-value">
              <a [href]="shippingOrderValue.trackingUrl" class="ui-help-link" target="_blank">
                {{ t('orderDetails.viewTracking') }}
              </a>
            </div>
          </div>
        }
        @if (shippingOrderValue.supportUrl) {
          <div class="order-section-item">
            <div class="order-section-item-title">
              {{ t('orderDetails.supportUrl') }}
            </div>
            <div class="order-section-item-value">
              <a [href]="shippingOrderValue.supportUrl" target="_blank" class="ui-help-link">
                {{ t('orderDetails.contactSupport') }}
              </a>
            </div>
          </div>
        }
        @if (shippingOrderValue.additionalInfo) {
          <div class="order-section-item">
            <div class="order-section-item-title">
              {{ t('orderDetails.additionalInfo') }}
            </div>
            <div class="order-section-item-value">
              {{ shippingOrderValue.additionalInfo }}
            </div>
          </div>
        }
        @if (shippingOrderValue.status !== 'CANCELLED' && shippingOrderValue.providerName !== 'correoargentino') {
          <div
            class="order-section-item"
            [ngClass]="{
              'order-shipping-cancel-alert': !canCancelShipping(),
            }"
          >
            <div class="order-section-item-title">
              {{ t('orderDetails.cancelShippingText') }}
            </div>
            @if (canCancelShipping()) {
              <pxw-button
                (click)="cancelShipping.emit()"
                [loading]="isCancelShippingRequestInProgress()"
                [disabled]="isCancelShippingRequestInProgress()"
                color="yellow"
                display="inline"
                size="sm"
                [rounded]="true"
              >
                {{ t('orderDetails.cancelShipping') }}
              </pxw-button>
            } @else {
              <pxw-alert type="danger" display="inline-block" size="sm">
                {{ t('orderDetails.cannotCancel') }}
              </pxw-alert>
            }
          </div>
        }
      }
    }
  }
  @if (tableNumber()) {
    <div class="order-section-item">
      <div class="order-section-item-title">{{ t('orderDetails.table') }}</div>
      <div class="order-section-item-value">
        {{ tableNumber() }}
      </div>
    </div>
  }
  @if (table(); as table) {
    <div class="order-section-item">
      <div class="order-section-item-title">{{ t('orderDetails.table') }}</div>
      <div class="order-section-item-value">{{ table.name }}</div>
    </div>
    @if (table.sectorName) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.sector') }}</div>
        <div class="order-section-item-value">{{ table.sectorName }}</div>
      </div>
    }
    @if (table.guests) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.guests') }}</div>
        <div class="order-section-item-value">{{ table.guests }}</div>
      </div>
    }
    @if (table.waiterName) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.waiter') }}</div>
        <div class="order-section-item-value">{{ table.waiterName }}</div>
      </div>
    }
    @if (serviceDuration(); as serviceDuration) {
      <div class="order-section-item">
        <div class="order-section-item-title">{{ t('orderDetails.serviceDuration') }}</div>
        <div class="order-section-item-value">
          {{ table.openedAt | date: 'HH:mm' }} → {{ table.closedAt | date: 'HH:mm' }} ({{
            serviceDuration
          }})
        </div>
      </div>
    }
    @if (canViewTableSession()) {
      <div class="order-section-item">
        <div class="order-section-item-value order-section-item-value--end">
          <pxw-button
            appareance="outline"
            color="blue"
            size="sm"
            [rounded]="true"
            (click)="viewTableSession.emit()"
          >
            {{ t('orderDetails.viewTableSession') }}
          </pxw-button>
        </div>
      </div>
    }
  }
</ng-container>
